module.exports = __webpack_public_path__ + "img/plus.ae77acc3.png";